<!-- eslint-disable vuejs-accessibility/label-has-for -->

<template>
  <div class="login-view">
    <div class="login-card">
      <h1 class="login-title">Iniciar sesión</h1>
      <form class="login-form" @submit.prevent="onSubmit">
        <div class="login-field">
          <label for="loginUsername" class="login-label">Usuario</label>
          <input
            id="loginUsername"
            v-model="username"
            class="login-input"
            type="text"
            autocomplete="username"
            :disabled="loading"
            placeholder="Ingrese su usuario"
          />
        </div>
        <div class="login-field">
          <label for="loginPassword" class="login-label">Contraseña</label>
          <input
            id="loginPassword"
            v-model="password"
            class="login-input"
            type="password"
            autocomplete="current-password"
            :disabled="loading"
            placeholder="Ingrese su contraseña"
          />
        </div>
        <p v-if="errorMessage" class="login-error" role="alert">
          {{ errorMessage }}
        </p>
        <button type="submit" class="login-submit" :disabled="!canSubmit || loading">
          {{ loading ? "Ingresando…" : "Ingresar" }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable quotes */
import { ref, computed } from "vue";
import {
  loginUsuario,
  STORAGE_ACCESS_TOKEN,
  STORAGE_REFRESH_TOKEN,
  applyStoredAuthToAxios,
} from "../Api/auth";

const emit = defineEmits(["success"]);

const username = ref("");
const password = ref("");
const loading = ref(false);
const errorMessage = ref("");

const canSubmit = computed(() => username.value.trim() !== "" && password.value !== "");

async function onSubmit() {
  errorMessage.value = "";
  loading.value = true;
  try {
    const result = await loginUsuario({
      username: username.value.trim(),
      password: password.value,
    });

    if (!result.success) {
      errorMessage.value = result.message || "No fue posible iniciar sesión";
      return;
    }

    sessionStorage.setItem(STORAGE_ACCESS_TOKEN, result.token);
    if (result.refreshToken) {
      sessionStorage.setItem(STORAGE_REFRESH_TOKEN, result.refreshToken);
    }
    applyStoredAuthToAxios();
    emit("success", result);
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
@import "../css/home.css";
</style>
